import { MutationTree } from 'vuex';
import { ITilesViewState, ITilesView } from './types';
import Vue from 'vue';
import _ from 'lodash';

export const mutations: MutationTree<ITilesViewState> = {
    loaded(state, args: { deviceNumber: string, view: ITilesView }) {
        const clonedView = _.cloneDeep(args.view);
        Vue.set(state.devices, args.deviceNumber, clonedView);
    },
    addOrUpdateTile(state, args: {deviceNumber: string, page: number, index: number | null, type: string, configuration: any}) {
        let device = state.devices[args.deviceNumber];
        if (!device) {
            device = {
                pages: [],
            };
            Vue.set(state.devices, args.deviceNumber, device);
        }
        if (!device.pages) {
            Vue.set(device, 'pages', []);
        }
        while (device.pages.length < args.page + 1) {
            Vue.set(device.pages, device.pages.length, { tiles: [] });
        }
        const page = device.pages[args.page];
        Vue.set(page.tiles, args.index != null ? args.index : page.tiles.length, {
            type: args.type,
            configuration: args.configuration,
        });
    },
    moveUp(state, args: {deviceNumber: string, page: number, index: number}) {
        const device = state.devices[args.deviceNumber];
        if (device) {
            const page = device.pages[args.page];
            if (page && args.index > 0 && page.tiles.length > args.index) {
                const current = page.tiles[args.index];
                const swapWith = page.tiles[args.index - 1];
                Vue.set(page.tiles, args.index, swapWith);
                Vue.set(page.tiles, args.index - 1, current);
            }
        }
    },
    moveDown(state, args: {deviceNumber: string, page: number, index: number}) {
        const device = state.devices[args.deviceNumber];
        if (device) {
            const page = device.pages[args.page];
            if (page && args.index >= 0 && page.tiles.length > args.index + 1) {
                const current = page.tiles[args.index];
                const swapWith = page.tiles[args.index + 1];
                Vue.set(page.tiles, args.index, swapWith);
                Vue.set(page.tiles, args.index + 1, current);
            }
        }
    },
    delete(state, args: {deviceNumber: string, page: number, index: number}) {
        const device = state.devices[args.deviceNumber];
        if (device) {
            const page = device.pages[args.page];
            if (page && args.index >= 0 && page.tiles.length > args.index) {
                Vue.delete(page.tiles, args.index);
            }
        }
    },
};
